<script>
import Multiselect from 'vue-multiselect';
export default {
  name: 'vehicle-identity',
  components: { Multiselect },
  props: {
    value: {},
  },
  data() {
    return {
      levelOptions: [
        { id: 'micro', name: 'Vehicle Identifier - Micro' },
        { id: 'core', name: 'Vehicle Identifier - Core' },
      ],
    };
  },
  computed: {
    computedLevel: {
      get() {
        return this.levelOptions.find(
          (option) => option.id === this.value.level
        ) || null;
      },
      set(newVal) {
        this.value.level = newVal.id;
      },
    },
  },
  mounted() { },
  methods: {},
};
</script>
<template>
  <div style="margin-top: 15px; padding-left: 15px" class="card row no-gutter">
    <div class="col-lg-5 col-12">
      <div class="card-header bg-navyblue">
        <strong>Vehicle Identifier</strong>
      </div>
      <div class="card-block bg-white">
        <div class="form-group row no-gutter">
          <p>
            Manage the level of Auto-Copilot assistance that's right for your
            workshop.
          </p>
        </div>
        <div class="form-group row no-gutter">
          <label for="partssearch-api-input" tabindex="0" class="col-sm-5 col-form-label">Vehicle
            Identification</label>
          <div class="col-sm-7">
            <div class="d-flex">
              <toggle-button v-model="value.active" id="ps-enabled-input" class="mb-0 rs-toggle__button" color="#5E79FF"
                :sync="true" :width="40" :labels="false" />
              <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                <template v-if="value.active">Active</template>
                <template v-else>Not Active</template>
              </span>
            </div>
          </div>
        </div>

<!--        <div class="form-group row no-gutter rs-toggle">-->
<!--          <label class="col-sm-5 col-form-label" for="ps-enabled-input">-->
<!--            Choose the level-->
<!--            <p style="-->
<!--                color: rgba(0, 0, 0, 0.5);-->
<!--                padding-right: 25px;-->
<!--                margin-top: 5px;-->
<!--                text-align: justify;-->
<!--              ">-->
<!--              <strong>Micro</strong> - Best for assessment photos taken in high resolution in-->
<!--              bays with ecxceptional lighting.-->
<!--            </p>-->
<!--            <p style="-->
<!--                color: rgba(0, 0, 0, 0.5);-->
<!--                padding-right: 25px;-->
<!--                margin-top: 5px;-->
<!--                text-align: justify;-->
<!--              ">-->
<!--              <strong>Core</strong> - Best for assessment photos in varius assessment locations-->
<!--              and lighting conditions.-->
<!--            </p>-->
<!--          </label>-->
<!--          <div class="col-sm-7">-->
<!--            <multiselect v-model="computedLevel" :options="levelOptions" :showLabels="false" :option-height="29"-->
<!--              :max-height="203" placeholder="choose the level" :close-on-select="true" track-by="id" label="name">-->
<!--            </multiselect>-->
<!--          </div>-->
<!--        </div>-->

        <!-- <div class="form-group row no-gutter">
          <label tabindex="0" class="col-sm-5 col-form-label">
            Default Location
            <p
              style="
                color: rgba(0, 0, 0, 0.5);
                padding-right: 25px;
                margin-top: 5px;
                text-align: justify;
              "
            >
              Choose the default Shop location from the Partssearch shop
              locations in your Account. Shop locations can be added
              automatically with each request for Pricing.
            </p>
          </label>
          <div class="col-sm-7"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<style scoped></style>
